import MediumSelect from "../../piece/MediumSelect";
import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {MacCommandOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)

    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <MacCommandOutlined/> Medium
            </FilterButton>
            <Modal
                title='Medium Filter'
                open={visible}
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            mediumFilter: {
                                text: 'Medium',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <MediumSelect
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}